import { createSelector } from 'reselect';
import createReducer from 'granite-admin/utils/ducks/create-reducer';

// ActionsNames - <NOUN>/<VERB>_<NOUN>
const UPDATE_PREFERENCE = 'common/preferences/UPDATE_PREFERENCE';

// Action creator name: <VERB><NOUN>
// Export actions
export function updatePreferences(data) {
  return {
    type: UPDATE_PREFERENCE,
    data: data
  };
}

// state name - <NOUN>
const defaultState = {
  preferences: {}
};

// Reducers - <NOUN>_<VERB>_REDUCER
function UPDATE_PREFERENCE_REDUCER(state, action) {
  const updatedState = {
    ...state.preferences
  };
  const updatedAction = {
    ...action.data
  };
  const updatedPreferences = {
    ...updatedState,
    ...updatedAction
  };
  return Object.assign({}, state, {
    preferences: updatedPreferences
  });
}
const handlers = {
  [UPDATE_PREFERENCE]: UPDATE_PREFERENCE_REDUCER
};

// Selectors
const preferencesSelector = state => state.common.preferences;
export const preferences = createSelector(preferencesSelector, state => state.preferences);

// export reducers as default
export default createReducer(defaultState, handlers);